// Shopper account API: register / log in, forgot password (email code), profile, addresses, orders.
import { apiRequest } from './api';

export const accountService = {
  // Register: mobile + email + password. Log in: email + password.
  register: ({ phone, email, password }) => apiRequest('/account/register', { method: 'POST', body: { phone, email, password } }),
  login: (email, password) => apiRequest('/account/login', { method: 'POST', body: { email, password } }),
  // Forgot password: 6-digit code emailed, then code + new password
  forgotPassword: email => apiRequest('/account/forgot-password', { method: 'POST', body: { email } }),
  resetPassword: ({ email, code, password }) => apiRequest('/account/reset-password', { method: 'POST', body: { email, code, password } }),

  me: () => apiRequest('/account/me'),
  updateProfile: profile => apiRequest('/account/me', { method: 'PUT', body: profile }),
  // currentPassword is not needed when the account has no password yet (made at checkout)
  changePassword: (currentPassword, newPassword) => apiRequest('/account/password', { method: 'PUT', body: { currentPassword, newPassword } }),

  addAddress: address => apiRequest('/account/addresses', { method: 'POST', body: address }),
  updateAddress: (id, address) => apiRequest(`/account/addresses/${id}`, { method: 'PUT', body: address }),
  deleteAddress: id => apiRequest(`/account/addresses/${id}`, { method: 'DELETE' }),

  // claimIds: guest orders placed from this browser — linked to the account if the mobile number matches
  orders: (claimIds = []) => apiRequest('/account/orders', { params: { claim: claimIds.join(',') } })
};
